import { render, staticRenderFns } from "./SubscriptionFeatures.vue?vue&type=template&id=d2716d78"
import script from "./SubscriptionFeatures.vue?vue&type=script&lang=js"
export * from "./SubscriptionFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2716d78')) {
      api.createRecord('d2716d78', component.options)
    } else {
      api.reload('d2716d78', component.options)
    }
    module.hot.accept("./SubscriptionFeatures.vue?vue&type=template&id=d2716d78", function () {
      api.rerender('d2716d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/marketing/SubscriptionFeatures.vue"
export default component.exports